export default __webpack_public_path__ + "static/media/fluent_mail-16-filled.6aa194ed.svg";